import { CSSObject } from '@chakra-ui/react';

export const TakeActionWrapper: CSSObject = {
  bg: 'white',
  borderBottomRadius: 'md',
  px: '2',
};
